import { useCallback, useEffect, useState } from "react";
import {
  listarFormacionesPorEstudiante,
  obtenerHistorialFormacion,
} from "../../../../services/formacionesService";
import { showToast } from "../../../../utils/showToast";

export default function useHistorialAcademico(estudianteId) {
  const [formaciones, setFormaciones] = useState([]);
  const [historial, setHistorial] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const cargar = useCallback(async () => {
    if (!estudianteId) {
      setFormaciones([]);
      setHistorial([]);
      return;
    }
    setLoading(true);
    try {
      const actuales = await listarFormacionesPorEstudiante(estudianteId);
      const historialResp = await obtenerHistorialFormacion(estudianteId);
      setFormaciones(Array.isArray(actuales) ? actuales : []);
      setHistorial(Array.isArray(historialResp) ? historialResp : []);
      setError(null);
    } catch (err) {
      console.error(err);
      setError(err.message || "No se pudo cargar el historial académico.");
      showToast({ type: "danger", message: err.message || "No se pudo cargar historial." });
    } finally {
      setLoading(false);
    }
  }, [estudianteId]);

  useEffect(() => {
    cargar();
  }, [cargar]);

  return { formaciones, historial, loading, error, reloadHistorial: cargar };
}
